import { render, staticRenderFns } from "./defaultRole.vue?vue&type=template&id=416d1550&scoped=true&"
import script from "./defaultRole.vue?vue&type=script&lang=js&"
export * from "./defaultRole.vue?vue&type=script&lang=js&"
import style0 from "./defaultRole.vue?vue&type=style&index=0&id=416d1550&prod&lang=less&"
import style1 from "./defaultRole.vue?vue&type=style&index=1&id=416d1550&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416d1550",
  null
  
)

export default component.exports